import { ICallRequest } from '../models/ICallRequest'
import { getEmptySearchResult, ISearchResult } from '../models/IDialerState'
import { MY_CONNECT_TYPE } from '../models/MyConnectType'

import { dialerAPI, TDialerSearchPayload } from './api/DialerApi'

export class DialerService {
  public async search(payload: TDialerSearchPayload): Promise<ISearchResult> {
    let result = getEmptySearchResult()
    if ((payload.input && payload.type) || payload.type === MY_CONNECT_TYPE.Favourite) {
      const response = await dialerAPI.search(payload)
      result = response.data
    }

    return result
  }

  public call = async (payload: ICallRequest) => {
    return dialerAPI.call(payload)
  }

  public isEmailInAD = async (email: string) => {
    const res = await dialerAPI.checkEmailInAD(email)
    return Boolean(res.data.firstName && res.data.lastName)
  }
}

export const dialerService = new DialerService()
